var map = {
	"./app.dev.aerosimple.com/favicon.png": 1836,
	"./app.dev.aerosimple.com/logo.png": 1837,
	"./default/favicon.png": 1838,
	"./default/logo.png": 1839,
	"./gcr.unosimple.com/favicon.ico": 1840,
	"./gcr.unosimple.com/logo.jpg": 1841
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1835;